import { reactive,computed,watch, ref, onMounted} from 'vue';
import {useI18n} from 'vue-i18n';
import { useStore } from 'vuex';
export default {
  components: {
  },
  props: {
    title: {  // placeholder
      type: String,
      default:'Connection Status'
    },
    data:{
      type: Array,
      default:[]
    },
    total_text: {  // placeholder
      type: String,
      default:''
    },
    table_title_name: {  // placeholder
      type: String,
      default:'Period'
    },
  },
  setup(props) {//emit 傳到複層_emit('update:{function}', val)
    const { t } = useI18n();
    const store = useStore()
    const {data} = props;
    const root = ref(null);
    let target = null;
    //data
    let state = reactive({
      total_ratio:0,
      _data:[],
      Data:[],
      hoverCol: '',
      hoverRow: '',
      mouseOver: '',
    })


    onMounted(() => {
      target = root.value;
      textLimitHoverPopup()

      window.addEventListener("resize", (() => {
        textLimitHoverPopup()
      }));
    })

    store.watch((state) => (state.langIsSelected ), () => {
      state.hoverRow = '';
      state.mouseOver = '';
      textLimitHoverPopup()
    })

    const textLimitHoverPopup = () => {
      target = root.value;
      setTimeout(() => {
        if (!target) return
        let a = target.querySelectorAll('.normalTd')
        for (let i = 0; i < a.length; i++) {
          if (a[i].scrollHeight > a[i].clientHeight) {
            a[i].classList.add('hasPopUp')
          } else {
            a[i].classList.remove('hasPopUp')
          }
        }
      }, 1)
    }

    const hoverEffect = (e, val, ri) => {
      if (e.target.children.length) {//出
        if (!e.target.children[0].classList.contains('hasPopUp')) {
          return
        }else{
          state.hoverRow = '';
          state.mouseOver = '';
        }
      } else { //進
        if(e.target.classList.contains('hasPopUp')){
          state.hoverRow = ri;
          state.mouseOver = val;
        }
      }
      
    }
    // methods
    const Data = computed(() => {
      state._data = data;
      var total = 0;
      for(var a = 0;a<data.length;a++){
        total += data[a].amount;
      }
      var dasharray = 0;
      for(a = 0;a<state._data.length;a++){
        // _data[a].ratio = data[a].amount/total*100;
        state._data[a].ratio = Math.round(data[a].amount/total*100);
        dasharray+=data[a].amount/total*100;
        state._data[a].dasharray=dasharray+" "+(100-dasharray)
        if(a == state._data.length-2){
          console.log('yuyuyyu')
          state.total_ratio = Math.round(dasharray);
        }
        if(a == state._data.length-1){
          state._data[a].dasharray="100 0"
        }
      }
      var reversed=[];
      for(a = state._data.length-1;a>=0;a--){
        reversed.push(state._data[a]);
      }
      return reversed
    })
    watch(
      () => props.data, () => {
        var data = props.data;
        state._data = data;
        var total = 0;
        for(var a = 0;a<data.length;a++){
          total += data[a].amount;
        }
        var dasharray = 0;
        for(a = 0;a<state._data.length;a++){
          // _data[a].ratio = data[a].amount/total*100;
          state._data[a].ratio = Math.round(Number(data[a].amount)/total*100) ? Math.round(Number(data[a].amount)/total*100) : 0;
          dasharray+=data[a].amount/total*100 ? data[a].amount/total*100 : 0;
          state._data[a].dasharray=dasharray+" "+(100-dasharray)
          if(a == state._data.length-2){
            state.total_ratio = Math.round(dasharray);
          }
          if(a == state._data.length-1){
            state._data[a].dasharray="100 0"
          }
        }
        state.Data=[];
        for(a = state._data.length-1;a>=0;a--){
          state.Data.push(state._data[a]);
        }
      }
    )
    //mounted
    return {
      state,
      Data,
      t,
      hoverEffect,
      root,
      textLimitHoverPopup
    }
  }
}